import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.4rem",
  fontWeight: 700,
  color: theme.palette.gray["15"]
}))
